let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d9TxV")).then(() => parcelRequire('bXFr8'));